












































































































import { Vue, Component } from "vue-property-decorator";
import { vxm } from "@/store";
import SignInDialog from "@/components/sign-in-dialog.vue";

@Component({
  components: {
    "sign-in-dialog": SignInDialog
  }
})
export default class AppBar extends Vue {
  title = "";
  signInDialog = false;
  titleDialog = false;

  close() {
    this.titleDialog = false;
  }

  get publicResults() {
    return vxm.results.game.publicResults.includes("game");
  }

  get dark() {
    return this.$vuetify.theme.dark;
  }

  set dark(value) {
    this.$vuetify.theme.dark = value;
    vxm.app.dark = value;
  }

  get fullScreen() {
    return vxm.app.fullScreen;
  }

  set fullScreen(value) {
    vxm.app.fullScreen = value;
    if (document.fullscreenElement) {
      document.exitFullscreen();
    } else {
      document.documentElement.requestFullscreen();
    }
  }

  get fluid() {
    return vxm.app.fluid;
  }

  set fluid(value) {
    vxm.app.fluid = value;
  }

  get drawer() {
    return vxm.app.drawer;
  }

  set drawer(value) {
    vxm.app.drawer = value;
  }

  get game() {
    return vxm.games.db[vxm.results.gameId];
  }

  get logoUrl() {
    return vxm.results.game.logoUrl;
  }

  get user() {
    return vxm.auth.user;
  }

  signOut() {
    vxm.auth.signOut();
  }
}
